import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';

const AltTitle = ({text, specialClass}) => {

  const [ref, inView, entry] = useInView({
    threshold: 1,
    triggerOnce: true
  });


  const [stroke, setStroke] = useState(false);

  return (
    <h1 className={`alt-title red-white-text ${inView && stroke && "alt-visible"} ${specialClass}`} ref={ref}>
      {
        text
      }
    </h1>
  )
}

export default AltTitle;